import React from "react";

import { useLogin } from "./useLogin.tsx";
import LoginUI from "./Login.ui.tsx";

const Login: React.FC = () => {
  const LoginProps = useLogin();

  return <LoginUI {...LoginProps} />;
};

export default Login;
